import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class PhysicalTemplateCriteria extends BasicCriteria {
visionCode: string;
visionCodeList: string[];
}

